import React, { createContext, useContext } from "react";

const theme = {
    color: {
        companyColor: "#075E54",
        blue: "#5E50F9",
        indigo: "#6610f2",
        purple: "#6a008a",
        pink: "#E91E63",
        red: "#f96868",
        orange: "#f2a654",
        yellow: "#f6e84e",
        green: "#46c35f",
        teal: "#58d8a3",
        cyan: "#57c7d4",
        white: "#ffffff",
        gray: "#434a54",
        grayLight: "#aab2bd",
        grayLighter: "#e8eff4",
        grayLightest: "#e6e9ed",
        black: "#000000",
        primary: "#844fc1",
        secondary: "#6c7293",
        success: "#21bf06",
        info: "#3b86d1",
        warning: "#f39915",
        danger: "#dc3545",
        light: "#f8f9fa",
        dark: "#282f3a",
      },
}

export {theme}
